import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import erpFetcher from "@/common/fetchErpnextServices";
var postAppointmentData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var request_id, rescheduled_datestamp, rescheduled_from_timestamp, rescheduled_to_timestamp, rescheduling_reason_id, is_reschedule, params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          request_id = _ref.request_id, rescheduled_datestamp = _ref.rescheduled_datestamp, rescheduled_from_timestamp = _ref.rescheduled_from_timestamp, rescheduled_to_timestamp = _ref.rescheduled_to_timestamp, rescheduling_reason_id = _ref.rescheduling_reason_id, is_reschedule = _ref.is_reschedule;
          params = {
            request_id: request_id,
            rescheduled_datestamp: rescheduled_datestamp,
            rescheduled_from_timestamp: rescheduled_from_timestamp,
            rescheduled_to_timestamp: rescheduled_to_timestamp,
            rescheduling_reason_id: rescheduling_reason_id,
            is_reschedule: is_reschedule
          };
          _context.n = 1;
          return erpFetcher(null, true).post('inspection-appointment/reschedule', params);
        case 1:
          res = _context.v;
          return _context.a(2, res || null);
      }
    }, _callee);
  }));
  return function postAppointmentData(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default postAppointmentData;